import React from 'react';
import './Whatsapp.css';

function Whatsapp() { 
    return (
        <a target="_blank" href="https://api.whatsapp.com/send?phone=60123347378&text=" class="whatsapp-button"><i class="fab fa-whatsapp"></i></a>
    );
}
export default Whatsapp;
